<template>
  <v-breadcrumbs
    :items="items"
    class="breadcrumbs px-10 pb-0 pt-8 black--text d-flex justify-space-between"
    divider="/"
  >
    <template slot="item" slot-scope="props">
      <router-link :to="{ name: props.item.href }" class="link black--text">{{
        $t(props.item.name)
      }}</router-link>
      <v-btn
        v-if="create !== null && create !== undefined"
        tile
        color="primary"
        @click="$router.push({ name: create })"
      >
        <v-icon left>
          add_circle
        </v-icon>
        Add
      </v-btn>
    </template>
  </v-breadcrumbs>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      create: null
    };
  },

  watch: {
    $route() {
      const vm = this;

      vm.updateBreadcrumbs();
    }
  },

  mounted() {
    const vm = this;

    vm.updateBreadcrumbs();
  },

  methods: {
    updateBreadcrumbs() {
      const vm = this;

      vm.items = vm.$route.meta.breadcrumb;
      vm.create = vm.$route.meta.create;
    }
  }
};
</script>

<style>
.breadcrumbs .link {
  text-decoration: none;
  color: #737373;
  font: bold 24px Sans-Serif;
  letter-spacing: -1px;
  white-space: nowrap;
  display: inline-block;
  position: relative;
}
</style>
